import { m } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Button, Typography } from '@mui/material';
// components
import { MotionContainer, varBounce } from '../../../components/animate';
// assets
import { PageNotFoundIllustration } from '../../../assets/illustrations';


/**
 * @module Layouts/Mantainance/Page404
 * @summary This is a React component for a 404 error page with a message, illustration, and a button to return
 * to the login page.
 * @description A React functional component that renders a 404 error page with a title, a message, an
 * illustration, and a button to return to the login page. The component uses the `Helmet` component
 * from the `react-helmet-async` library to set the page title dynamically. It also uses the
 * `framer-motion` library to add animations to the page elements.
 * @returns {React.ReactElement} The `Page404` component is being returned as a View.
 */

const Page404 = () => {
    return ( 
        <>
            <Helmet>
                <title> 404 Not found | Flexia </title>
            </Helmet>

            <MotionContainer>
                <m.div variants={varBounce().in}>
                    <Typography variant="h3" paragraph>
                        Sorry, we can't find the resource you are looking for!
                    </Typography>
                </m.div>

                <m.div variants={varBounce().in}>
                    <Typography sx={{ color: 'text.secondary' }}>
                        Sorry, we can't find the resource you are looking for! Please update the URL you are trying to access, checko carefully that is written correctly
                    </Typography>
                </m.div>

                <m.div variants={varBounce().in}>
                    <PageNotFoundIllustration
                        sx={{
                        height: 260,
                        my: { xs: 5, sm: 10 },
                        }}
                    />
                </m.div>

                <Button to="/auth/login" component={RouterLink} size="large" variant="contained">
                    Go back
                </Button>
            </MotionContainer>
        </>
    );
}
 
export default Page404;